import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  SiReact, SiTypescript, SiNextdotjs, SiNodedotjs,
  SiStyledcomponents, SiTailwindcss, SiGit, SiGithub,
  SiExpo, SiGraphql, SiDocker,
} from 'react-icons/si';
import { FaMobile } from 'react-icons/fa';
import Reveal from '../Reveal';
import {
  TechSection,
  TechShell,
  TechHeader,
  HeaderCopy,
  SectionTag,
  SectionTitle,
  SectionSubtitle,
  LeadCard,
  LeadLabel,
  LeadTitle,
  LeadText,
  GroupGrid,
  TechGroup,
  GroupTitle,
  GroupDesc,
  TechList,
  TechItem,
} from './TechStack.styles';

const techGroups = [
  {
    titleKey: 'tech.group0Title',
    descKey: 'tech.group0Desc',
    items: [
      { icon: <SiReact />, label: 'React', color: '#61dafb' },
      { icon: <SiNextdotjs />, label: 'Next.js', color: '#ffffff' },
      { icon: <SiTypescript />, label: 'TypeScript', color: '#3178c6' },
      { icon: <SiStyledcomponents />, label: 'Styled Comp.', color: '#db7093' },
    ],
  },
  {
    titleKey: 'tech.group1Title',
    descKey: 'tech.group1Desc',
    items: [
      { icon: <FaMobile />, label: 'React Native', color: '#61dafb' },
      { icon: <SiExpo />, label: 'Expo', color: '#ffffff' },
      { icon: <SiTailwindcss />, label: 'Tailwind', color: '#06b6d4' },
      { icon: <SiGraphql />, label: 'GraphQL', color: '#e535ab' },
    ],
  },
  {
    titleKey: 'tech.group2Title',
    descKey: 'tech.group2Desc',
    items: [
      { icon: <SiNodedotjs />, label: 'Node.js', color: '#339933' },
      { icon: <SiGit />, label: 'Git', color: '#f05032' },
      { icon: <SiGithub />, label: 'GitHub', color: '#f0f6fc' },
      { icon: <SiDocker />, label: 'Docker', color: '#2496ed' },
    ],
  },
];

const TechStack: React.FC = () => {
  const { t } = useTranslation();

  return (
    <TechSection>
      <TechShell>
        <Reveal>
          <TechHeader>
            <HeaderCopy>
              <SectionTag>{t('tech.tag')}</SectionTag>
              <SectionTitle>
                {t('tech.title')} <span>{t('tech.titleGradient')}</span>
              </SectionTitle>
              <SectionSubtitle>{t('tech.subtitle')}</SectionSubtitle>
            </HeaderCopy>

            <LeadCard>
              <LeadLabel>{t('tech.leadLabel')}</LeadLabel>
              <LeadTitle>{t('tech.leadTitle')}</LeadTitle>
              <LeadText>{t('tech.leadSubtitle')}</LeadText>
            </LeadCard>
          </TechHeader>
        </Reveal>

        <GroupGrid>
          {techGroups.map((group, index) => (
            <Reveal key={group.titleKey} delay={index * 90}>
              <TechGroup>
                <div>
                  <GroupTitle>{t(group.titleKey)}</GroupTitle>
                  <GroupDesc>{t(group.descKey)}</GroupDesc>
                </div>

                <TechList>
                  {group.items.map((tech) => (
                    <TechItem key={tech.label} $color={tech.color}>
                      {tech.icon}
                      <span>{tech.label}</span>
                    </TechItem>
                  ))}
                </TechList>
              </TechGroup>
            </Reveal>
          ))}
        </GroupGrid>
      </TechShell>
    </TechSection>
  );
};

export default TechStack;

